import React, { PureComponent, memo, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap'
import { connect } from 'react-redux';
import { Nav, NavDropdown } from 'react-bootstrap';

import { establecerUsuarioConectado } from '../../store/usuario/actions';
import { establecerParametros, establecerGoogleKey } from '../../store/parametros/actions';
import { SiteRutas, ImagenesRutas } from '../../request/RutasConfig';
import { Obtener_Simbolo_Moneda_Request, Obtener_Estado_Active_Directory_Request, Obtener_Google_Maps_Key_Request } from '../../request/ParametroRequest';
import Menu from './Menu/Menu';

class Header extends PureComponent {
    state = {
        googleKey: ''
    }

    componentDidMount() {
        if (!this.props.usuario.usuarioLoguedo) {
            this.props.history.replace({ pathname: SiteRutas.Login });
        }
        if (!this.props.empresa || !this.props.empresa.Id) {
            this.props.history.replace({ pathname: SiteRutas.Parametros });
        }
        else {
            if (!this.props.callCenter || !this.props.callCenter.Id) {
                this.props.history.replace({ pathname: SiteRutas.Parametros });
            }
            else {
                this.obtenerGoogleMapsKey(this.props.empresa.Id, this.props.callCenter.Id);
            }

            this.obtener_simbolo_moneda(this.props.empresa.Id);
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.empresa && this.props.empresa.Id && this.props.empresa.Id !== prevProps.empresa.Id) {
            this.obtener_simbolo_moneda(this.props.empresa.Id);
            this.obtenerEstadoActiveDirectory();
            this.obtenerGoogleMapsKey(this.props.empresa.Id, this.props.callCenter.Id);
        }
    }

    // METODOS

    obtenerEstadoActiveDirectory = async () => {
        const response = await Obtener_Estado_Active_Directory_Request();
        if (response.Exitoso) {
            this.props.establecerParametros({ activoAD: response.Datos });
        }
        else {
            alertError(response.Mensaje);
        }
    }

    obtener_simbolo_moneda = async (pEmpresa) => {
        if (this.props.token) {
            const response = await Obtener_Simbolo_Moneda_Request(this.props.token, pEmpresa);
            if (response.Exitoso) {
                this.props.establecerParametros({ simboloMoneda: response.Datos });
            }
        }
    }

    obtenerGoogleMapsKey = async (pEmpresa_Id, pCallCenter_Id) => {
        if (this.props.token) {
            this.props.establecerGoogleKey('');
            window.gm_authFailure = this.gm_authFailure;

            const response = await Obtener_Google_Maps_Key_Request(this.props.token, pEmpresa_Id, pCallCenter_Id);
            if (response.Exitoso && response.Datos) {

                this.removeScript('jsGoogleApi');
                this.setState({ googleKey: response.Datos }, () => {
                    window.initMap = this.setGoogleKey;
                    const googleApi = `https://maps.googleapis.com/maps/api/js?key=${response.Datos}&libraries=places,marker&loading=async&callback=initMap`;
                    this.loadScript('jsGoogleApi', googleApi);
                });
            }
            else {
                this.removeScript('jsGoogleApi');
                window.initMapNoKey = this.setGoogleNoKey;
                const googleApi = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=places,marker&loading=async&callback=initMapNoKey`;
                this.loadScript('jsGoogleApi', googleApi);
            }
        }
    }

    setGoogleKey = () => {
        const gmErrores = document.getElementsByClassName("gm-err-container");
        if (!gmErrores || gmErrores.length === 0) {
            this.props.establecerGoogleKey(this.state.googleKey);
        }
    }

    setGoogleNoKey = () => {
        this.props.establecerGoogleKey('no-key');
    }

    gm_authFailure = () => {
        const gmErrores = document.getElementsByClassName("gm-err-container");
        gmErrores[0].remove();

        this.removeScript('jsGoogleApi');
        window.initMapNoKey = this.setGoogleNoKey;
        const googleApi = `https://maps.googleapis.com/maps/api/js?v=3.exp&callback=initMapNoKey`;
        this.loadScript('jsGoogleApi', googleApi);
    }

    loadScript = (id, src) => {
        const element = document.getElementById(id);
        if (!element) {
            let tag = document.createElement('script');
            tag.async = true;
            tag.src = src;
            tag.id = id;
            document.getElementsByTagName('head')[0].appendChild(tag);
        }
    }

    removeScript = (id) => {
        let element = document.getElementById(id);
        if (element) {
            element.parentNode.removeChild(element);
        }
    }

    // EVENTOS

    onlogoutRequest = () => {
        this.props.establecerUsuarioConectado(false);
        this.props.history.push(SiteRutas.Login);
    }

    render() {

        const nombreEmpresa = this.props.empresa && this.props.empresa.Id ? this.props.empresa.Nombre : '';
        const nombreCallCenter = this.props.callCenter && this.props.callCenter.Id ? this.props.callCenter.Nombre : '';
        const nombreSucursal = this.props.sucursal && this.props.sucursal.Id ? this.props.sucursal.Nombre : '';

        const componenteUsuario = <div className="col-auto text-right">
            <Nav className="user">
                <NavDropdown title={<Fragment>
                    {this.props.usuario.imagen_url ? <img src={this.props.usuario.imagen_url} alt="avatar usuario" /> : null}
                    {this.props.usuario.nombre}
                </Fragment>} id="navbarParametros">
                    {
                        !this.props.usuario.activo_AD ?
                            <>
                                <LinkContainer to={SiteRutas.CambiarContrasena}><NavDropdown.Item>Cambiar Contraseña</NavDropdown.Item></LinkContainer>
                                <NavDropdown.Divider />
                            </>
                            : <LinkContainer to={SiteRutas.CambiarPin}><NavDropdown.Item>Cambiar PIN</NavDropdown.Item></LinkContainer>
                    }
                    <NavDropdown.Item onClick={() => this.onlogoutRequest()}>Salir</NavDropdown.Item>
                </NavDropdown>
            </Nav>
        </div>;

        return (
            <Fragment>
                <div className="brand">
                    <div className="row">
                        <div className="logo col">
                            <img src={ImagenesRutas.Logo_LD} alt="Logo Logical Data" />
                        </div>
                        <div className="col-auto text-right">
                            <Nav className="parametros">
                                <NavDropdown title="Parámetros" id="navbarParametros">
                                    <NavDropdown.Item>Empresa: {nombreEmpresa}</NavDropdown.Item>
                                    <NavDropdown.Item>Call Center: {nombreCallCenter}</NavDropdown.Item>
                                    <NavDropdown.Item>Sucursal: {nombreSucursal}</NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </div>
                    </div>
                </div>
                <Menu>{componenteUsuario}</Menu>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        usuario: state.usuario,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter,
        mapa: state.parametros.mapa
    };
};

const mapDispatchToProps = {
    establecerUsuarioConectado,
    establecerParametros,
    establecerGoogleKey
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(memo(Header)));